import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinnerInCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM9.69552 4.46927C9.89654 4.95457 10 5.47471 10 6H9C9 5.60603 8.9224 5.21593 8.77164 4.85195C8.62087 4.48797 8.3999 4.15726 8.12132 3.87868C7.84274 3.6001 7.51203 3.37913 7.14805 3.22836C6.78407 3.0776 6.39397 3 6 3C5.60603 3 5.21593 3.0776 4.85195 3.22836C4.48797 3.37913 4.15726 3.6001 3.87868 3.87868C3.6001 4.15726 3.37913 4.48797 3.22836 4.85195C3.0776 5.21593 3 5.60603 3 6H2C2 5.47471 2.10346 4.95457 2.30448 4.46927C2.5055 3.98396 2.80014 3.54301 3.17157 3.17157C3.54301 2.80014 3.98396 2.5055 4.46927 2.30448C4.95457 2.10346 5.47471 2 6 2C6.52529 2 7.04543 2.10346 7.53073 2.30448C8.01604 2.5055 8.45699 2.80014 8.82843 3.17157C9.19986 3.54301 9.4945 3.98396 9.69552 4.46927Z",
		fill: "#C6C7C8"
	})]
});
const ForwardRef = forwardRef(SvgSpinnerInCircle);
export { ForwardRef as ReactComponent };
